<template>
  <!-- 培训机构列表 -->
  <div>
    <top :keyword="''" :tab="'school'"></top>
    <ul class="cdetail">
      <li>
        <div class="ctop">
          <pic style="float:left;" :src="cdetails.logoUrl" width="600px" height="400px" alt />
          <div class="ctop-text" style="float:right;width:566px;height:400px;">
            <p style="text-align:left;font-size:22px;margin-top:10px;">{{ cdetails.name }}</p>
            <p style="text-align:left;font-size:16px;margin-top:10px;">{{ cdetails.occupationName }} |
              {{ cdetails.gradeName }}</p>
            <p style="text-align:left;font-size:16px;margin-top:10px;">证书类型：{{ cdetails.certificateType }}</p>
            <p style="text-align:left;font-size:16px;margin-top:10px;">培训地点：{{ cdetails.address }}</p>
            <p style="text-align:left;font-size:16px;margin-top:10px;">培训机构：{{ cdetails.offlineName }}</p>
            <p style="text-align:left;font-size:16px;margin-top:10px;">授课时间：{{ cdetails.beginTime }} - {{ cdetails.endTime
            }}
            </p>
            <p style="text-align:left;font-size:16px;margin-top:10px;">授课教师：{{ cdetails.teacherName }}</p>
            <p style="text-align:left;font-size:16px;margin-top:10px;">负责人及电话：{{ cdetails.responsibleName }} /
              {{ cdetails.responsiblePhone }}</p>
            <p style="text-align:left;font-size:16px;margin-top:10px;">报名人数：{{ cdetails.enrolment }}</p>
            <el-button type="primary" style="float:left;margin-top:20px;width:150px;height:50px;font-size:16px;"
              :style="{ background: (registered ? '#7c7f82' : '#3ab57f'), borderColor: (registered ? '#7c7f82' : '') }"
              @click="Applyjoin">{{ title }}</el-button>
          </div>
        </div>
        <div class="ctop" style="height:600px;">
          <div class="introduce" style="width:100%;height:60px;background:#eee;">
            <p style="padding-left:30px;text-align:left;font-size:26px;line-height:60px;">开设课程</p>
          </div>
          <div class="topdiv">
            <div class="tab-card" style="display: block;">
              <el-table :data="tableData" border style="width: 100%;margin:0 auto;">
                <el-table-column prop="courseName" label="课程名称" width="250" align="center"></el-table-column>
                <el-table-column prop="teacherName" label="授课教师" width="120" align="center"></el-table-column>
                <el-table-column prop="address" label="培训地点" align="center"></el-table-column>
                <el-table-column prop="beginTime" label="开始时间" width="220" height="30" align="center"></el-table-column>
                <el-table-column prop="endTime" label="结束时间" width="220" height="30" align="center"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <bottom></bottom>
  </div>
</template>
<script>
import top from './top'
import bottom from './bottom'

export default {
  name: 'ClassDetail',
  data () {
    return {
      //   activeName: 'first',
      idx: 2,
      cdetails: [],
      tableData: [],
      registered: false
    }
  },
  computed: {
    title: function () {
      if (this.registered) {
        return '已报名'
      }
      return '申请加入'
    }
  },
  created () {
    this.getdata()
    this.getOffclass()
  },
  methods: {
    tab (index) {
      this.idx = index
      var tabCardCollection = document.querySelectorAll('.tab-card'),
        len = tabCardCollection.length
      for (var i = 0; i < len; i++) {
        tabCardCollection[i].style.display = 'none'
      }
      tabCardCollection[index].style.display = 'block'
    },
    getdata () {
      // 接收到a.vue页面传递的id
      let id = this.$route.params.id
      this.$axios
        .get(
          this.$managePath + '/offline/api/class/detail/' + id
        )
        .then(res => {
          console.log(res.data.data)
          if (res.data.status === 1) {

            this.cdetails = res.data.data
            if (
              res.data.data.checkStatus >= 0 &&
              res.data.data.checkStatus < 3
            ) {
              this.registered = true
            }
          }
        })
        .catch(err => { })
    },
    getOffclass () {
      let id = this.$route.params.id
      this.$axios
        .get(
          this.$managePath +
          '/offline/api/class/courses?classId=' +
          id
        )
        .then(res => {
          if (res.data.status == '1') {
            this.tableData = res.data.data
          }
        })
    },
    Applyjoin () {
      if (this.registered) {
        return
      }
      let data = localStorage.getItem('Authorization')
      if (data) {
        this.$confirm(
          '<p>请报名的学员务必认真阅读此报名须知，一旦报名成功，即视为您认可本校的一切规定，并成为一种协议。 </p><br><p>报名流程：</p><p>阅读相关课程资料----了解开课时间----确定要报班次----填写报名登记表----确认报名----取得线上学习资格和线下考勤卡----确定线下学习时间 <br> 注：1、学员也可在线下联系机构进行报名； 2、凡是满本省就业培训补贴政策的学员均可享受补贴，并根据申请资质准备个人申请材料； 3、学员所报班级不足开班人数时, 本校保留不开班的权利。</p>',
          '报名须知',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true
          }
        )
          .then(() => {
            let id = this.$route.params.id
            let data = {
              classId: id
            }
            var qs = require('qs')
            this.$axios
              .post(
                this.$managePath +
                '/offline/api/class/applyFor',
                qs.stringify(data),
                {
                  headers: {
                    'Content-Type':
                      'application/x-www-form-urlencoded'
                  }
                }
              )
              .then(res => {
                if (res.data.status == '1') {
                  this.$alert('申请加入成功', {
                    confirmButtonText: '确定'
                  })
                } else {
                  this.$alert('已加入该班级,不能重复加入', {
                    confirmButtonText: '确定'
                  })
                }
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消报名'
            })
          })
      } else {
        this.$confirm('您还没有登录，请先去登录', '未登录', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        })
          .then(() => {
            this.$router.push('/student/login')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消报名'
            })
          })
      }
    }
  },
  beforeMount () { },
  watch: {},
  components: {
    bottom: bottom,
    top: top
  }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
@import '../assets/css/cms.css';

.cdetail {
  width: 1184px;
  height: auto;
  /* background: #eee; */
  margin: 20px auto;
}

.ctop {
  width: 100%;
  height: 400px;
  /* border: 1px solid #ccc; */
  margin-bottom: 30px;
}

.el-tabs__nav-scroll {
  height: 60px;
}

.ctopul {
  overflow: hidden;
  width: 100%;
  height: 60px;
  /* background: #ccc; */
}

.ctopul li {
  list-style: none;
  float: left;
  /* width:150px; */
  height: 54px;
  font-size: 20px;
  line-height: 60px;
  /* border:1px solid #000; */
  text-align: center;
}

.topdiv {
  width: 100%;
  text-align: center;
  height: 540px;
  margin-top: 20px;
}

.active {
  border-bottom: 6px solid #3ab57f;
}

.tab-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/classDetail.vue